
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.39 13.167c.449 0 .677-.193.853-.686l1.028-2.838h4.86l1.02 2.838c.176.493.405.686.853.686.492 0 .817-.29.817-.747 0-.158-.035-.299-.096-.492L14.884 1.68c-.211-.572-.59-.844-1.187-.844-.571 0-.958.272-1.16.835l-3.84 10.274c-.071.194-.097.334-.097.484 0 .457.298.738.79.738zm2.303-4.878l1.978-5.537h.053l1.968 5.537h-3.999zM.883 13.167c.369 0 .615-.185.764-.66l.633-1.827h3.05l.633 1.828c.158.483.404.659.773.659.449 0 .765-.29.765-.712 0-.158-.035-.316-.114-.536L4.926 5.37c-.194-.527-.554-.852-1.134-.852-.554 0-.905.325-1.099.852L.223 11.92c-.078.22-.105.387-.105.536 0 .422.308.712.765.712zm1.784-3.691l1.081-3.252h.106l1.09 3.252H2.666z","fill":"#000"}})])
          )
        }
      }
    